export const formatPrice = (price: number) => {
    const format = new RegExp(/\B(?=(\d{3})+(?!\d))/, 'g');

    return price.toString().replace(format, ' ');
}

export const appendUrlGetParameter = (url: string, key: string, value: string) => {
    const parts = new URL(url);
    const params = new URLSearchParams(parts.search);

    params.append(key, value);

    return parts.origin + parts.pathname + '?' + params.toString();
}
